import React from "react";
import { Link } from "react-router-dom";

import { CartAPI } from "api/cart-api";

import PopupService from "shared/popup-service";

import { ACTION_TYPES } from "constants/action-types";
// TODO: Issue MRP-2773
// eslint-disable-next-line import/no-named-as-default
import STATUS_TYPES from "constants/status-types";
import { POPUP_TYPES } from "constants/popups.const";

import { trackTransactionCreated } from "shared/segment";
import { getUserData, getUserRetailerId } from "store/selectors/user";
import { getCartItemsByRetailer } from "store/selectors/cart";
import { setError } from "store/actions/errors";

export function setStatus(status) {
  return {
    type: ACTION_TYPES.CART.SET_STATUS,
    payload: status
  };
}

export function addItem(item, units) {
  PopupService.makeCartPopup(item);

  return {
    type: ACTION_TYPES.CART.ADD_ITEM,
    payload: { item, units }
  };
}

export function modifyItem(item, units) {
  return {
    type: ACTION_TYPES.CART.MODIFY_ITEM,
    payload: { item, units }
  };
}

export function removeItem(itemId) {
  return {
    type: ACTION_TYPES.CART.REMOVE_ITEM,
    payload: { itemId }
  };
}

export function doRemoveByRetailerId(itemId) {
  return {
    type: ACTION_TYPES.CART.REMOVE_BY_RETAILER_ID,
    payload: itemId
  };
}

export function clearCart() {
  return {
    type: ACTION_TYPES.CART.CLEAR_CART
  };
}

export function setTransaction(retailerId, data) {
  return {
    type: ACTION_TYPES.CART.SET_TRANSACTION,
    payload: { retailerId, data }
  };
}

export function doAddItem(item, units) {
  return async (dispatch, getState) => {
    await dispatch(setStatus(STATUS_TYPES.PENDING));

    const state = getState();
    const { provider } = item;
    const cartItems = getCartItemsByRetailer(state);
    const retailerId = getUserRetailerId(state);
    // drop the permissions
    const { permissions: _, ...user } = getUserData(state);

    const cartUnits = cartItems[provider]
      ? // TODO: Issue MRP-2773
    // eslint-disable-next-line arrow-body-style
    cartItems[provider].map(cartItem => ({
          listing: cartItem.id,
          sizes: cartItem.units
        }))
      : [];
    return CartAPI.createTransaction({
      // TODO: Issue MRP-2773
      // eslint-disable-next-line unicorn/consistent-destructuring
      provider: item.provider,
      receiver: retailerId,
      // TODO: Issue MRP-2773
      // eslint-disable-next-line unicorn/consistent-destructuring
      units: [...cartUnits, { listing: item.id, sizes: units }]
    }).then(
      async response => {
        await dispatch(addItem(item, units));
        await dispatch(setTransaction(provider, response));
        dispatch(setStatus(STATUS_TYPES.LOADED));
        trackTransactionCreated({ listing: item, user });
      },
      error => {
        const { data } = error;
        if (data.alreadytransaction) {
          /* eslint-disable max-len */
          const message = {
            // yourmove: "You requested this item and an order has already been created. Go to your Pending Orders to complete checkout.",
            yourmove: (
              <span>
                You requested this item and an order has already been created. Go to your{" "}
                <Link to="/orders/pending/purchases">Pending Orders</Link> to complete checkout.
              </span>
            ),
            theirmove:
              "You already requested this item from this retailer.  Please wait for them to approve or decline the transaction."
          };
          PopupService.makePopup(POPUP_TYPES.MESSAGE, message[data.alreadytransaction]);
          dispatch(setStatus(STATUS_TYPES.LOADED));
        } else {
          dispatch(setError({ type: "cart", errors: [data] }));
          dispatch(setStatus(STATUS_TYPES.FAILED));
        }
      }
    );
  };
}

export function doModifyItem(item, units) {
  return async (dispatch, getState) => {
    await dispatch(setStatus(STATUS_TYPES.PENDING));
    const { provider } = item;
    const state = getState();
    const cartItems = getCartItemsByRetailer(state);
    const retailerId = getUserRetailerId(state);
    // drop the permissions
    const { permissions: _, ...user } = getUserData(state);

    // TODO: Issue MRP-2773
    // eslint-disable-next-line arrow-body-style
    const cartUnits = cartItems[provider]?.map(cartItem => ({
      listing: cartItem.id,
      // TODO: Issue MRP-2773
      // eslint-disable-next-line unicorn/consistent-destructuring
      sizes: cartItem.id === item.id ? units : cartItem.units
    }));

    // TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/explicit-length-check
    if (Object.keys(units).length !== 0) {
      return CartAPI.createTransaction({
        // TODO: Issue MRP-2773
        // eslint-disable-next-line unicorn/consistent-destructuring
        provider: item.provider,
        receiver: retailerId,
        units: cartUnits
      }).then(
        async response => {
          await dispatch(modifyItem(item, units));
          await dispatch(setTransaction(provider, response));
          dispatch(setStatus(STATUS_TYPES.LOADED));
          trackTransactionCreated({ listing: item, user });
        },
        error => {
          dispatch(setError({ type: "cart", errors: [error?.response?.data] }));
          dispatch(setStatus(STATUS_TYPES.FAILED));
        }
      );
    }
    return {};
  };
}

export function doRemoveItem(item) {
  return async (dispatch, getState) => {
    await dispatch(setStatus(STATUS_TYPES.PENDING));

    const { provider } = item;
    const state = getState();
    const cartItems = getCartItemsByRetailer(state);
    const retailerId = getUserRetailerId(state);
    // drop the permissions
    const { permissions: _, ...user } = getUserData(state);

    const cartUnits = cartItems[provider];
    const filteredCartUnits = cartUnits
      .// TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/consistent-destructuring, unicorn/explicit-length-check
    filter(cartItem => cartItem.id !== item.id && Object.values(cartItem.units).length)
      .// TODO: Issue MRP-2773
    // eslint-disable-next-line arrow-body-style
    map(cartItem => ({
        listing: cartItem.id,
        sizes: cartItem.units
      }));

    // TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/explicit-length-check
    if (!filteredCartUnits.length) {
      dispatch(setStatus(STATUS_TYPES.LOADED));
      // TODO: Issue MRP-2773
      // eslint-disable-next-line unicorn/consistent-destructuring
      dispatch(doRemoveByRetailerId(item.provider));

      return false;
    }

    // TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/explicit-length-check
    if (cartUnits.length) {
      return CartAPI.createTransaction({
        // TODO: Issue MRP-2773
        // eslint-disable-next-line unicorn/consistent-destructuring
        provider: item.provider,
        receiver: retailerId,
        units: filteredCartUnits
      }).then(
        async response => {
          // TODO: Issue MRP-2773
          // eslint-disable-next-line unicorn/consistent-destructuring
          await dispatch(removeItem(item.id));
          await dispatch(setTransaction(provider, response));
          dispatch(setStatus(STATUS_TYPES.LOADED));
          trackTransactionCreated({ listing: item, user });
        },
        error => {
          dispatch(setError({ type: "cart", errors: [error?.response?.data] }));
          dispatch(setStatus(STATUS_TYPES.FAILED));
        }
      );
    }
    // TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/consistent-destructuring
    await dispatch(removeItem(item.id));
    // TODO: Issue MRP-2773
    // eslint-disable-next-line unicorn/no-null
    await dispatch(setTransaction(provider, null));
    return dispatch(setStatus(STATUS_TYPES.LOADED));
  };
}
